<template>
    <div>
        <app-header>
            <template slot="title">Produkte</template>
            <template slot="right">Hinzufügen</template>
        </app-header>
        <div class="container table-wrapper-scroll-y">
            <app-list-produkte></app-list-produkte>
        </div>
        <div id="nav">
            <app-nav></app-nav>
        </div>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'
  import ListProdukte from '../components/produkte/ListProdukte'

  export default {
    components: {
      appHeader: Header,
      appNav: Nav,
      appListProdukte: ListProdukte
    }
  }
</script>

<style lang="scss" scoped>
    .container {
        padding: 20px;
        margin: auto;
    }

    .table-wrapper-scroll-y {
        max-height: 550px;
    }
</style>
